import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const APP_ADMIN_URL = 'https://app.shiftcheck.app/admin';

/**
 * The admin CRM lives in the app repo (app.shiftcheck.app/admin), not here.
 * This route exists only to send anyone who lands on www/admin over there,
 * preserving whatever subpath/query/hash they arrived with.
 */
const AdminRedirectPage = () => {
  const location = useLocation();

  useEffect(() => {
    const subpath = location.pathname.replace(/^\/admin/, '');
    const target = `${APP_ADMIN_URL}${subpath}${location.search}${location.hash}`;
    window.location.replace(target);
  }, [location]);

  return (
    <div className="pt-24">
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <p className="text-gray-500">Redirecting to the admin console…</p>
        </div>
      </section>
    </div>
  );
};

export default AdminRedirectPage;
